<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Panduan</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              Panduan
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="col-lg-8 offset-lg-2 p-0">
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  @input="search"
                  v-model="filter.q"
                  placeholder="Cari panduan"
                >
                <div class="input-group-append">
                  <button
                    id="btnSearchPenduduk"
                    class="btn btn-primary"
                    type="button"
                  >
                    <i class="fa fa-search" />
                  </button>
                </div>
              </div>
            </div>
            <div v-if="panduan.length > 0">
              <div
                v-for="p in panduan"
                :key="p.id_berita"
                class="card m-0"
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-3">
                      <img
                        v-if="p.thumbnail"
                        :src="$store.getters.getBaseUrl+'/api/file/'+p.thumbnail"
                        alt=""
                        class="w-100"
                      >
                      <img
                        v-else
                        :src="require('@/assets/stisla/img/news/img01.jpg')"
                        class="w-100"
                      >
                    </div>
                    <div class="col-9">
                      <router-link :to="'/panduan/'+p.slug">
                        <h4 class="panduan-title">
                          {{ p.judul_berita }}
                        </h4>
                      </router-link>
                      <p>{{ p.snippet.substr(0, 100) }}</p>
                      <p class="text-right">
                        <router-link :to="'/panduan/'+p.slug">
                          Selengkapnya
                        </router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="loadingPanduan"
              class="spinner-container"
            >
              <div class="spinner" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<style scoped>
h4.panduan-title {
	color: #34395e; font-weight: normal
}
</style>

<script>
import _ from 'lodash'
import LayoutAdmin from './../layouts/Admin.vue'

export default {
	name: 'App',
	data(){
        return {
			panduan: [],
            filter: {
				q: ''
			},
			loadingPanduan: false
        }
	},
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		}
	},
	components: {
		LayoutAdmin
	},
	methods: {
		getPanduan(){
			this.panduan = []
			this.loadingPanduan = true
			this.$store.dispatch('fetchPanduan', this.filter).then(res => {
				if(res.data.status){
					this.panduan = res.data.data
				}
				this.loadingPanduan = false
			})
		},
		search: _.debounce(function (e) {
			this.filter.search = e.target.value
			this.getPanduan()
        }, 500),
	},
	mounted(){
		document.querySelector('title').innerHTML = this.$store.getters.getAppName + ' | Penduduk'
	},
	created(){
		this.getPanduan()
	}
}
</script>

<style>

</style>
